import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import type { Option } from '@atlassian/jira-issue-field-select-base/src/common/types.tsx';
import type { IssueLinkType } from '../../common/types.tsx';
import IssuelinksType from './link-types/index.tsx';
import IssueLinksSearch from './search/index.tsx';
import type { Props } from './types.tsx';

export const IssueLinksEdit = (props: Props): React.JSX.Element => {
	const {
		fieldId,
		autoCompleteUrl,
		onChange,
		linkTypeOptions,
		autoFocus = false,
		value,
		fetchSuggestionsOnMount,
		onCloseMenuOnScroll,
		isDropdownMenuFixedAndLayered,
		isDisabled,
		isRequired,
		inputId,
		ariaLabel,
		ariaLabelledBy,
	} = props;

	const onLinkTypeChange = (val: IssueLinkType): void => {
		onChange({
			linkType: val,
			issues: value ? value.issues : [],
		});
	};

	const onLinkSearchChange = (val: Option[]): void => {
		if (value) {
			onChange({
				linkType: value.linkType,
				issues: val,
			});
		}
	};

	return (
		<FlexColumn data-testid="issue-field-issue-links.ui.edit.issue-links">
			<IssuelinksType
				options={linkTypeOptions}
				autoFocus={autoFocus}
				value={value ? value.linkType : undefined}
				onChange={onLinkTypeChange}
				onCloseMenuOnScroll={onCloseMenuOnScroll}
				isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
				isDisabled={isDisabled}
				inputId={inputId}
				isRequired={isRequired}
				ariaLabel={ariaLabel}
				ariaLabelledBy={ariaLabelledBy}
			/>
			<IssueLinksSearch
				fieldId={fieldId}
				value={value ? value.issues : undefined}
				fetchSuggestionsOnMount={fetchSuggestionsOnMount}
				autoCompleteUrl={autoCompleteUrl}
				onChange={onLinkSearchChange}
				onCloseMenuOnScroll={onCloseMenuOnScroll}
				isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
				isDisabled={isDisabled}
			/>
		</FlexColumn>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FlexColumn = styled.div<{
	children?: ReactNode;
}>({
	display: 'flex',
	flexDirection: 'column',
});
